import BulkEditListPanel from './bulkEditListPanel.container';

export default BulkEditListPanel